import {
  createMinLengthRule,
  createRequiredItem,
  createRequiredString,
  runValidationRules,
} from 'lib/mobileDesignSystem';

export interface ApprovalFormErrors {
  roleId: string | null;
  reason: string | null;
}

export interface ApprovalFormInput {
  roleId: number | null;
  reason: string;
}

export const roleSelectRules = [createRequiredItem('Debe seleccionar un rol')];

export const reasonRules = [
  createRequiredString('La razón es requerida'),
  createMinLengthRule(2, 'La razón debe tener al menos 2 caracteres'),
];

export function validateApprovalForm(
  form: ApprovalFormInput,
): ApprovalFormErrors {
  return {
    roleId: runValidationRules(form.roleId, roleSelectRules),
    reason: runValidationRules(form.reason, reasonRules),
  };
}

export function isApprovalFormValid(form: ApprovalFormInput): boolean {
  const errors = validateApprovalForm(form);
  return errors.roleId == null && errors.reason == null;
}
